var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("bp-directional", [
    _c(
      "div",
      _vm._g(
        {
          ref: "dropdown",
          staticClass: "dropdown",
          class: { "-open": _vm.expanded },
        },
        {
          mouseleave: _vm.mouseleave,
          focusout: _vm.focusout,
          mouseover: _vm.mouseover,
          mouseup: _vm.mouseup,
          mousedown: _vm.mousedown,
        }
      ),
      [
        _c(
          "a",
          {
            ref: "link",
            staticClass: "dropdown__link",
            class: _vm.labelClass,
            attrs: {
              "aria-controls": _vm.id,
              "aria-expanded": String(_vm.expanded),
              href: _vm.href,
            },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.click.apply(null, arguments)
              },
              keydown: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "space", 32, $event.key, [
                    " ",
                    "Spacebar",
                  ])
                )
                  return null
                $event.preventDefault()
                return _vm.click.apply(null, arguments)
              },
            },
          },
          [
            _vm._t("link", function () {
              return [_vm._v(_vm._s(_vm.label))]
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "dropdown__button",
                attrs: {
                  "aria-controls": _vm.id,
                  "aria-expanded": String(_vm.expanded),
                },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                    return _vm.click.apply(null, arguments)
                  },
                },
              },
              [
                _vm._t("button", function () {
                  return [
                    _c(
                      "svg",
                      {
                        staticClass: "dropdown__icon",
                        attrs: {
                          viewBox: "0 0 24 24",
                          "stroke-width": "1",
                          stroke: "currentColor",
                          fill: "none",
                        },
                      },
                      [_c("polyline", { attrs: { points: "6 9 12 15 18 9" } })]
                    ),
                  ]
                }),
              ],
              2
            ),
          ],
          2
        ),
        _vm._v(" "),
        _c("transition", { attrs: { name: _vm.transition } }, [
          _vm.expanded
            ? _c(
                "div",
                {
                  staticClass: "dropdown__content",
                  attrs: { id: _vm.id },
                  on: {
                    keydown: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "esc", 27, $event.key, [
                          "Esc",
                          "Escape",
                        ])
                      )
                        return null
                      $event.preventDefault()
                      return _vm.close.apply(null, arguments)
                    },
                  },
                },
                [_vm._t("default")],
                2
              )
            : _vm._e(),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }